import { useEffect } from 'react';

declare global {
  interface Window {
    [key: string]: () => void;
  }
}

export const useReservation = (fn: () => void, name: string) => {
  useEffect(() => {
    window[name] = fn;
    return () => {
      delete window[name];
    };
  }, [fn, name]);
};
